/* ============================================================
   «ENCUENTRA TU AGUACERO» · popup juego (Pedro 2026-10-13, con capturas del «Try Your Luck» de Grüns: «quiero armar un popup
   creativo con algo así, pero usando nuestros assets de 3d que hicimos con hermes, algo sumamente elevado, interactivo, para dar
   un 10% OFF adicional en su pedido» · «10% en todo, a debug primero»).
   Memoria 3×3 con las regaderas 3D de Hermes (toma 09 del banco: Plata, Negro, Dorado, Blanco). Siempre se gana: la cara de cada
   carta se decide al voltearla y la 3.ª igual sale en el 3.º o 4.º toque; lo volteado se queda boca arriba. Premio → «¿Qué te
   molesta más del agua de tu casa?» → correo (+ WhatsApp opcional) → Klaviyo (lista + propiedad agua_molestia) y el código al
   carrito con /cart/update.js sin quitar los que ya había. Si Klaviyo falla, el código se aplica igual.
   Cuándo: solo en la PDP, una vez por sesión, a los ~10 s visibles, o antes si sube rápido el scroll (móvil) o hay intento de
   salida (escritorio). Nunca sobre el configurador ni otro modal, ni a quien ya jugó o ya trae el código. A/B estable por
   visitante (juego_ab_pct); el brazo viaja al pedido como _agc_juego (agc-encuesta.js) y en los eventos enc_juego_*.
   ?juego=1 lo abre ya · ?juego_dry=1 no llama a Klaviyo · ?nopopup=1 lo apaga.
   v2 ESTILO GRÜNS (Pedro 2026-10-26: «mejor hay que hacer uno como gruns, me gusta más, después de elegir respuesta, piden correo y listo» →
   «mejor con 35% off»): fondo claro cálido, cartas con «?» que se voltean a premios escritos («35% OFF», «Envío gratis»…), la ducha 3D abajo;
   «Ganaste 35% OFF + envío gratis» → 4 botones de la molestia → solo correo (sin WhatsApp) → «Listo, ya está en tu pedido». Con juego_precios
   el premio es un precio por paquete que aplica el configurador al pagar (JUEGO35-{n}); el carrito no se toca aquí.
   ============================================================ */
(function () {
  'use strict';
  var CFG = document.getElementById('AgcJuegoCfg');
  if (!CFG || window.AGCJuego) return;
  var D = CFG.dataset, H = document.documentElement;
  var bandera = function (k) { return new RegExp('(?:^|[?&])' + k + '=1(?:&|$)').test(location.search); };
  var FORZADO = bandera('juego'), DRY = bandera('juego_dry'), NOPOP = bandera('nopopup'), TEASER = false;   /* TEASER: se abrió desde la pestaña del borde */
  var CODIGO = String(D.codigo || 'JUEGO-AGUA10').trim().toUpperCase();
  var PRECIOS = !!String(D.precios || '').trim();   /* juego_precios: el código es un prefijo (JUEGO35-) + duchas, lo pone el configurador */
  var PCT = parseInt(D.pct, 10); if (!(PCT >= 0 && PCT <= 100)) PCT = 50;
  var OFF = parseInt(D.off, 10); if (!(OFF >= 0 && OFF < 100)) OFF = 10;   /* 0 = sin % extra: el juego activa el precio de la página (prueba $1099, Pedro 2026-11-03: «activando su 57% off pero sin el 5% extra») */   /* % que regala el juego (ajuste juego_off; Pedro 2026-10-18: 5%) */
  var PREMIO = String(D.premio || '').trim() || OFF + '% OFF';   /* texto del premio en las cartas (ajuste juego_premio; Pedro 2026-10-26: «35% OFF») */
  var ESPERA = Math.max(3, parseInt(D.espera, 10) || 10) * 1000;
  /* A/B DEL CANAL (Pedro 2026-10-27: «quiero un test 50/50 del popup de cartas… uno pide correo, quiero otro que pida whatsapp, si gana whatsapp armamos
     flujo en revie»): % de visitantes a los que el paso final les pide WhatsApp en vez de correo (ajuste juego_canal_wa; 0 = todos correo, como antes).
     Mismo premio y mismo código. ?canal=wa|correo lo fuerza. El canal viaja en los eventos (canal) y en el pedido (_agc_juego: juego|wa|gano|reclamo). */
  var CANAL_WA = parseInt(D.canalWa, 10); if (!(CANAL_WA >= 0 && CANAL_WA <= 100)) CANAL_WA = 0;
  var KL = { company: 'SFNwUe', list: D.lista || 'TmrPHJ', revision: '2023-12-15', base: 'https://a.klaviyo.com/client/' };
  var MED_URL = 'https://web-production-7de4a.up.railway.app/api/popup/event';
  /* llaves nuevas con el 35%: todos arrancan de cero, aunque hayan jugado o reclamado el juego anterior (Pedro 2026-10-26: «que todos entren
     como si fuese nuevo todo… a menos de que lo activen con el nuevo y ya se quede activado») */
  /* MODO PROMO (Pedro 2026-11-02, Pre-Buen Fin: «enfocado a activar el 50% OFF + 5% adicional… que descubra sus 3 cartas, ganan en el 100% de los casos»):
     ajustes juego_tres (las 3 primeras cartas son el premio), juego_titulo / juego_sub / juego_extra (textos), juego_otros (lo que dicen las demás
     cartas, separadas con |) y juego_llave (llave nueva por promo: quien jugó el juego anterior vuelve a jugar). Vacíos = como antes. */
  var TRES = D.tres === '1', TITULO = String(D.titulo || '').trim() || 'Prueba tu suerte', SUB = String(D.sub || '').trim() || 'Junta 3 iguales y descubre tu premio';
  var EXTRA = String(D.extra || '').trim() || '+ envío gratis', LLAVE = String(D.llave || '').trim().replace(/[^A-Za-z0-9]/g, '');
  var KEY = LLAVE ? 'agcJuego' + LLAVE : 'agcJuego35', KEY_SES = LLAVE ? 'agcJuegoVisto' + LLAVE : 'agcJuegoVisto35';
  var RM = false; try { RM = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var MOVIL = false; try { MOVIL = matchMedia('(pointer: coarse)').matches; } catch (e) {}
  var ACABADOS = [{ k: 'plata', n: 'Plata' }, { k: 'negro', n: 'Negro' }, { k: 'dorado', n: 'Dorado' }, { k: 'blanco', n: 'Blanco' }];
  /* respuestas de Pedro 2026-10-26 (antes: piel_reseca, cabello_sin_vida, olor_a_cloro, familia); los valores viejos siguen en tools/juego_reporte.py */
  var MOLESTIAS = [
    { v: 'frizz_cabello', t: 'Resequedad y frizz en el cabello', i: '<path d="M7 20c0-6 1.5-11 5-15"/><path d="M11 20c0-5 1-9 4-13"/><path d="M15 20c0-4 .8-7 3-10"/>' },
    { v: 'caida_cabello', t: 'Caída y cabello débil', i: '<path d="M8 4c0 5 1 9 3 12"/><path d="M13 4c0 4 .6 7 2 9"/><path d="M10 19.5h.01M15.5 16.5h.01"/>' },
    { v: 'piel_reseca', t: 'Piel reseca o tirante', i: '<path d="M12 3.5c3.2 4 5.5 7.1 5.5 10a5.5 5.5 0 01-11 0c0-2.9 2.3-6 5.5-10z"/><path d="M9.5 14.5c.4 1.3 1.4 2 2.6 2.1"/>' },
    { v: 'agua_limpia', t: 'Solo quiero agua limpia', i: '<path d="M12 3.5c3.2 4 5.5 7.1 5.5 10a5.5 5.5 0 01-11 0c0-2.9 2.3-6 5.5-10z"/>' }
  ];
  var IMG = {}, LOOP = {};
  ACABADOS.forEach(function (a) { IMG[a.k] = D['img' + a.n]; LOOP[a.k] = D['loop' + a.n]; });

  /* ---------- memoria del visitante (todo con try/catch: modo privado, bloqueos) ---------- */
  function lee() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function guarda(o) { var s = lee(); for (var k in o) s[k] = o[k]; try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} return s; }
  /* el brazo sale de un número fijo por visitante: estable entre visitas y monótono si cambia el % (subir el % solo suma gente al juego) */
  var MEM = lee();
  if (!(MEM.u >= 0 && MEM.u < 1)) MEM = guarda({ u: Math.random(), desde: new Date().toISOString() });
  function brazo() { return MEM.u * 100 < PCT ? 'juego' : 'control'; }
  /* el canal sale de otro número fijo por visitante (independiente del brazo juego/control) */
  if (!(MEM.c >= 0 && MEM.c < 1)) MEM = guarda({ c: Math.random() });
  function canal() { var m = /(?:^|[?&])canal=(wa|correo)(?:&|$)/.exec(location.search); if (m) return m[1]; return MEM.c * 100 < CANAL_WA ? 'wa' : 'correo'; }
  var WA = canal() === 'wa';
  function reclamado() { return !!lee().rec; }
  function attr() { var s = lee(), b = brazo() + '|' + canal() + (FORZADO ? '|forzado' : ''); if (s.gano) b += '|gano'; if (s.rec) b += '|reclamo'; return b; }

  /* ---------- medición: mismo colector y sesión que la encuesta y el configurador; nada sale antes del primer toque humano (G25) ---------- */
  function sid() {
    var k = 'agcpn_sid', s = null;
    try { s = sessionStorage.getItem(k); } catch (e) {}
    if (!s) { s = Date.now().toString(36) + Math.random().toString(36).slice(2, 8); try { sessionStorage.setItem(k, s); } catch (e) {} }
    return s;
  }
  var cola = [], humano = false, dados = {};
  function enviar(ev, md) {
    try {
      md.lp = 'pdp-uno'; md.brazo = brazo(); md.pct = PCT; md.canal = canal(); md.canal_pct = CANAL_WA;
      if (FORZADO) md.forzado = 1;
      if (DRY) md.dry = 1;
      try { if (window.Shopify && Shopify.theme && Shopify.theme.role) md.role = Shopify.theme.role; } catch (e) {}   /* 'main' = LIVE */
      fetch(MED_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ session_id: sid(), event: 'enc_juego_' + ev, metadata: md, page_path: location.pathname }) }).catch(function () {});
    } catch (e) {}
  }
  function medir(ev, md, clave) {
    var id = ev + '|' + (clave == null ? '' : clave);
    if (dados[id]) return; dados[id] = 1;
    if (humano) enviar(ev, md || {}); else cola.push([ev, md || {}]);
  }
  function alHumano(e) {
    if (humano || (e && e.isTrusted === false)) return;
    humano = true; cola.splice(0).forEach(function (x) { enviar(x[0], x[1]); });
  }
  ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (t) { addEventListener(t, alHumano, { passive: true, capture: true }); });
  /* el brazo se mide una vez por sesión: es el denominador del A/B */
  (function () { var k = 'agcJuegoAB', ya = null; try { ya = sessionStorage.getItem(k); } catch (e) {}
    if (!ya) { medir('ab', { u: Math.round(MEM.u * 1000) / 1000 }); try { sessionStorage.setItem(k, '1'); } catch (e) {} } })();

  /* ---------- utilidades ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function conTiempo(p, ms) { return Promise.race([p, new Promise(function (_, no) { setTimeout(function () { no(new Error('tiempo')); }, ms); })]); }
  function jget(url) { return fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); }); }
  function jpost(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body || {}) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function codigos(cart) { return ((cart && cart.discount_codes) || []).map(function (d) { return String((d && d.code) || '').toUpperCase(); }).filter(Boolean); }
  function nombre(k) { for (var i = 0; i < ACABADOS.length; i++) if (ACABADOS[i].k === k) return ACABADOS[i].n; return k; }
  function vibra(p) { try { navigator.vibrate && navigator.vibrate(p); } catch (e) {} }
  var ICO_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICO_FLECHA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  /* ---------- ¿se puede abrir ahora? nunca encima del carrito u otro modal. Encima del configurador abierto SÍ (Pedro 2026-10-26: «cuando den
     click en COMPRAR AHORA… luego luego se abra el config pero también el popup siguiendo la apertura del configurador») ---------- */
  function bloqueado() {
    if (H.classList.contains('agc-uno-closing') || H.classList.contains('agc-esp2-on')) return 'config';
    if (document.querySelector('#agc-cfg .agc-island.open')) return 'config';
    if (document.body && document.body.classList.contains('agc-drawer-open')) return 'carrito';
    var ms = document.querySelectorAll('[aria-modal="true"]');
    for (var i = 0; i < ms.length; i++) {
      var m = ms[i]; if (m.closest('.agc-jg')) continue;
      var r = m.getBoundingClientRect(), cs = getComputedStyle(m);
      if (r.width > 40 && r.height > 40 && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05) return 'modal';
    }
    return '';
  }

  /* ---------- precarga perezosa: CSS + las 4 regaderas (nada de esto compite con la carga de la página) ---------- */
  var listo = null;
  function precarga() {
    if (listo) return listo;
    var css = new Promise(function (ok) {
      if (!D.css || document.querySelector('link[data-agc-jg]')) return ok();
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = D.css; l.setAttribute('data-agc-jg', '1');
      l.onload = l.onerror = function () { ok(); }; document.head.appendChild(l);
    });
    var imgs = [D.ducha, D.logo].filter(Boolean).map(function (src) {   /* v2: la ducha 3D y el logo (las cartas ya no llevan fotos) */
      return new Promise(function (ok) {
        var im = new Image(); im.decoding = 'async'; try { im.fetchPriority = 'low'; } catch (e) {}
        im.onload = function () { (im.decode ? im.decode() : Promise.resolve()).then(ok, ok); }; im.onerror = function () { ok(); }; im.src = src;
      });
    });
    listo = Promise.race([Promise.all([css].concat(imgs)), new Promise(function (ok) { setTimeout(ok, 3500); })]);
    return listo;
  }

  /* ---------- disparadores ---------- */
  var abierto = false, intentando = false, hecho = false, visible = 0, noAntes = 0;
  function enDays() { return false; }   /* Pedro 2026-10-16 lo apagó en Days; 2026-10-18 «prendelo al 100% de visitantes» con 5%: ya no se bloquea en Days */
  /* OFERTA 50/50 «Set Anual de regalo» (Pedro 2026-10-26, ajuste oferta_ab): en el brazo B el juego no sale y su código no cuenta. Manda el brazo que
     sorteó el configurador (window.AGC_OFERTA, agc-encuesta.js corre antes: mismo orden de defer); si no está, el mismo sorteo guardado
     (?oferta= o localStorage agcOferta), solo si la sección trae la prueba prendida (data-oferta) */
  function ofertaB() {
    var o = window.AGC_OFERTA; if (typeof o === 'string') return o === 'B';
    if (!D.oferta) return false;
    var m = /(?:^|[?&])oferta=([AB])(?:&|$)/i.exec(location.search); if (m) return m[1].toUpperCase() === 'B';
    try { return localStorage.getItem('agcOferta') === 'B'; } catch (e) { return false; }
  }
  function intenta(motivo) {
    if (abierto || intentando || hecho) return;
    if (ofertaB()) { hecho = true; return; }   /* brazo B de la oferta: nunca sale, ni con ?juego=1 */
    if (!FORZADO && enDays()) { hecho = true; return; }
    if (!FORZADO && !TEASER) {
      if (NOPOP) { hecho = true; return; }
      var s = lee(); if (s.rec || (s.jugo && s.vuelta)) { hecho = true; return; }   /* jugó y no reclamó: una vuelta más (abre) */
      var visto = null; try { visto = sessionStorage.getItem(KEY_SES); } catch (e) {} if (visto) { hecho = true; return; }
    }
    if (bloqueado()) { intentando = true; setTimeout(function () { intentando = false; intenta(motivo); }, 2500); return; }
    intentando = true;
    /* ¿ya trae el código? una sola lectura del carrito, justo antes de abrir */
    conTiempo(jget('/cart.js'), 4000).then(function (c) { return codigos(c).indexOf(CODIGO) !== -1; }, function () { return false; }).then(function (ya) {
      /* con off 0 el código es el de la página ($1099: PREBUENFIN-1099), que el configurador ya mete al carrito: no prueba que lo hayan reclamado;
         y si lo abren desde la pestaña, se abre (Pedro 2026-11-03: «cerre el popup, luego en los teasers les pico y no abre nada») */
      if (ya && !FORZADO && !TEASER && OFF > 0) { intentando = false; hecho = true; guarda({ rec: lee().rec || new Date().toISOString() }); quitaTeaser(); return; }
      if (!FORZADO && brazo() !== 'juego') { intentando = false; hecho = true; medir('elegible', { motivo: motivo }); return; }
      medir('elegible', { motivo: motivo });
      precarga().then(function () {
        intentando = false;
        if (bloqueado()) return setTimeout(function () { intenta(motivo); }, 2500);
        var falta = noAntes - Date.now();
        if (falta > 0) return setTimeout(function () { if (!abierto && !hecho) abre(FORZADO ? 'forzado' : motivo); }, falta);
        abre(FORZADO ? 'forzado' : motivo);
      });
    });
  }
  if (!NOPOP) {
    /* tiempo VISIBLE en la página (una pestaña precargada o en segundo plano no cuenta) */
    var reloj = setInterval(function () {
      if (hecho || abierto) return clearInterval(reloj);
      if (!document.hidden) visible += 500;
      if (visible >= Math.min(2000, ESPERA - 3000)) precarga();   /* temprano: si dan COMPRAR AHORA, el juego entra sin esperar su CSS */
      if (visible >= (FORZADO ? 600 : ESPERA)) intenta('tiempo');
    }, 500);
    /* móvil: sube rápido el scroll después de haber bajado (gesto típico de «me voy») */
    var maxY = 0, lastY = window.scrollY || 0, subida = 0, subeDesde = 0;
    addEventListener('scroll', function () {
      var y = window.scrollY || 0, t = Date.now();
      if (y > maxY) maxY = y;
      if (y < lastY) { if (!subida) subeDesde = t; subida += lastY - y; } else { subida = 0; }
      lastY = y;
      if (MOVIL && maxY > 600 && visible >= 4000 && subida > 180 && t - subeDesde < 380) intenta('scroll');
    }, { passive: true });
    /* escritorio: el cursor sale por arriba de la ventana */
    document.addEventListener('mouseout', function (e) { if (!MOVIL && !e.relatedTarget && e.clientY <= 0 && visible >= 4000) intenta('salida'); });
  }

  /* ---------- el reparto amañado: siempre se gana y la 3.ª igual sale en el 3.º o el 4.º toque (como Grüns) ---------- */
  function reparto(rnd) {
    var W = ACABADOS[Math.floor(rnd() * 4)].k;   /* el acabado ganador */
    var otros = ACABADOS.map(function (a) { return a.k; }).filter(function (k) { return k !== W; });
    var X = otros[Math.floor(rnd() * 3)];
    return { W: W, plan: TRES || rnd() < 0.25 ? [W, W, W] : [W, X, W, W], mazo: [W, W, W].concat(otros, otros) };   /* 3 del ganador + 2 de cada otro = 9 */
  }

  /* ---------- el popup ---------- */
  var R, SHEET, foco = null;
  /* cada «acabado» del reparto es un premio escrito en la carta: el ganador es PREMIO; los otros, premios menores (como las cartas de Grüns) */
  var OTROS = String(D.otros || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean); if (OTROS.length < 3) OTROS = ['15% OFF', 'Envío gratis', '25% OFF'];
  function cara(k, W) { if (k === W) return PREMIO; var o = ACABADOS.map(function (a) { return a.k; }).filter(function (x) { return x !== W; }); return OTROS[o.indexOf(k)] || PREMIO; }
  var ESTRELLA = '<svg viewBox="0 0 40 40" aria-hidden="true"><path d="M20 2c1.6 9.3 8.7 16.4 18 18-9.3 1.6-16.4 8.7-18 18-1.6-9.3-8.7-16.4-18-18 9.3-1.6 16.4-8.7 18-18z" fill="currentColor"/></svg>';
  function abre(motivo) {
    if (abierto) return; abierto = true;
    try { sessionStorage.setItem(KEY_SES, '1'); } catch (e) {}
    foco = document.activeElement;
    var RP = reparto(Math.random), W = RP.W, plan = RP.plan, mazo = RP.mazo;
    var toques = 0, caras = [], bloqueo = false, t0 = performance.now(), molestia = null, fase = 'juego';
    /* Pedro 2026-10-26 («si cierro el popup sin reclamarlo ya nunca me vuelve a salir?» → «dale directo a live»): quien jugó y se fue sin dejar
       su correo, en su siguiente visita entra directo a «Tu premio sigue aquí», una sola vez */
    var vuelta = (!FORZADO || TEASER) && !!lee().jugo && !lee().rec;
    if (vuelta) guarda({ vuelta: new Date().toISOString() });

    R = document.createElement('div'); R.className = 'agc-jg agc-jg--g'; R.setAttribute('role', 'dialog'); R.setAttribute('aria-modal', 'true'); R.setAttribute('aria-labelledby', 'agcJgT');
    var cartas = ''; for (var i = 0; i < 9; i++) cartas += '<button type="button" class="agc-jg-card" style="--i:' + i + '" aria-label="Carta ' + (i + 1) + ', boca abajo"><span class="agc-jg-in"><span class="agc-jg-back" aria-hidden="true">?</span><span class="agc-jg-face" aria-hidden="true"><b></b></span></span></button>';
    var opciones = MOLESTIAS.map(function (m, k) { return '<button type="button" class="agc-jg-opt agc-jg-r" style="--d:' + (k + 3) + '" data-v="' + m.v + '">' + esc(m.t) + '</button>'; }).join('');
    var logo = D.logo ? '<img class="agc-jg-logo" src="' + esc(D.logo) + '" alt="Aguacero" width="112" height="20">' : '';
    R.innerHTML =
      '<div class="agc-jg-bg"></div>' +
      '<div class="agc-jg-sheet">' +
        '<button type="button" class="agc-jg-x" aria-label="Cerrar">' + ICO_X + '</button>' +
        logo +
        '<section class="agc-jg-step is-on" data-step="juego">' +
          '<h2 id="agcJgT" class="agc-jg-t">' + esc(TITULO) + '</h2>' +
          '<p class="agc-jg-sub">' + esc(SUB) + '</p>' +
          '<div class="agc-jg-grid" role="group" aria-label="Cartas">' + cartas + '</div>' +
          '<p class="agc-jg-hint" aria-live="polite">Toca una carta para empezar</p>' +
          '<button type="button" class="agc-jg-no">Ahora no</button>' +
        '</section>' +
        '<section class="agc-jg-step" data-step="premio" hidden>' +
          '<p class="agc-jg-won agc-jg-r" style="--d:0">Ganaste</p>' +
          '<h2 class="agc-jg-big agc-jg-r" style="--d:1"><b>' + esc(PREMIO) + '</b><span>' + esc(EXTRA) + '</span></h2>' +
          '<p class="agc-jg-qt agc-jg-r" style="--d:2">Cuéntanos, ¿qué problema quieres resolver?</p>' +
          '<div class="agc-jg-opts">' + opciones + '</div>' +
        '</section>' +
        '<section class="agc-jg-step" data-step="correo" hidden>' +
          '<p class="agc-jg-won agc-jg-r" style="--d:0"><span class="agc-jg-mmol"></span></p>' +
          '<h2 class="agc-jg-t2 agc-jg-r" style="--d:1">Tu ' + esc(PREMIO) + ' te espera</h2>' +
          '<p class="agc-jg-sub agc-jg-r" style="--d:1">' + (WA ? 'Déjanos tu WhatsApp y lo dejamos listo en tu pedido.' : 'Déjanos tu correo y lo dejamos listo en tu pedido.') + '</p>' +
          '<form class="agc-jg-form agc-jg-r" style="--d:2" novalidate>' +
            (WA ? '<label class="agc-jg-field"><span class="agc-jg-lbl">Tu WhatsApp</span><span class="agc-jg-tel"><b aria-hidden="true">+52</b><input type="tel" name="tel" autocomplete="tel-national" inputmode="numeric" maxlength="24" placeholder="10 dígitos" aria-label="Tu WhatsApp, 10 dígitos" required></span></label>'
              : '<label class="agc-jg-field"><span class="agc-jg-lbl">Tu correo</span><input type="email" name="email" autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false" placeholder="tucorreo@ejemplo.com" required></label>') +
            '<p class="agc-jg-err" role="alert"></p>' +
            '<button type="submit" class="agc-jg-cta"><span>Aplicar mi ' + esc(PREMIO) + '</span>' + ICO_FLECHA + '</button>' +
            '<p class="agc-jg-legal">' + (WA ? 'Al reclamarlo aceptas recibir mensajes de Aguacero por WhatsApp. Te das de baja cuando quieras.' : 'Al reclamarlo aceptas recibir correos de Aguacero. Te das de baja cuando quieras.') + '</p>' +
          '</form>' +
        '</section>' +
        '<section class="agc-jg-step" data-step="listo" hidden>' +
          '<div class="agc-jg-ok agc-jg-r" style="--d:0" aria-hidden="true"><svg viewBox="0 0 52 52"><circle cx="26" cy="26" r="24"/><path d="M15 27l7.5 7.5L37.5 19"/></svg></div>' +
          '<h2 class="agc-jg-t2 agc-jg-r" style="--d:1"></h2>' +
          '<p class="agc-jg-note agc-jg-r" style="--d:2"></p>' +
          (PRECIOS ? '' : '<div class="agc-jg-code agc-jg-r" style="--d:2"><span>Tu código</span><b>' + esc(CODIGO) + '</b></div>') +
          '<button type="button" class="agc-jg-cta agc-jg-r" style="--d:3" data-elige><span>Elegir mi Aguacero</span>' + ICO_FLECHA + '</button>' +
        '</section>' +
        '<div class="agc-jg-deco" aria-hidden="true"><i class="agc-jg-st1">' + ESTRELLA + '</i><i class="agc-jg-st2">' + ESTRELLA + '</i>' +
          (D.ducha ? '<img class="agc-jg-ducha" src="' + esc(D.ducha) + '" alt="" decoding="async">' : '') + '</div>' +
      '</div>';
    document.body.appendChild(R);
    SHEET = R.querySelector('.agc-jg-sheet');
    H.classList.add('agc-jg-on');
    medir('visto', { motivo: motivo, ganador: W, plan: plan.length, v: 'gruns', vuelta: vuelta ? 1 : 0 });
    requestAnimationFrame(function () { requestAnimationFrame(function () { R.classList.add('is-on'); }); });
    SHEET.setAttribute('tabindex', '-1');
    setTimeout(function () { try { SHEET.focus({ preventScroll: true }); } catch (e) {} }, RM ? 30 : 420);

    var $ = function (s) { return R.querySelector(s); }, $$ = function (s) { return [].slice.call(R.querySelectorAll(s)); };
    var cards = $$('.agc-jg-card'), hint = $('.agc-jg-hint');

    /* ---------- cerrar: X, Esc o el fondo ---------- */
    var vivo = true;
    function tecla(e) {
      if (e.key === 'Escape') { e.preventDefault(); cierra('esc'); return; }
      if (e.key !== 'Tab') return;
      var f = $$('button:not([disabled]), input, [tabindex]:not([tabindex="-1"])').filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
    function cierra(como, luego) {
      if (!vivo) return; vivo = false;
      medir('cierra', { fase: fase, como: como, toques: toques });
      document.removeEventListener('keydown', tecla, true);
      R.classList.remove('is-on'); R.classList.add('is-off');
      setTimeout(function () { H.classList.remove('agc-jg-on'); R.remove(); abierto = false; hecho = true; TEASER = false;
        if (reclamado()) quitaTeaser(); else if (como !== 'elige') { guarda({ cerro: new Date().toISOString() }); teaser(); }
        if (luego) luego(); else if (foco && foco.focus) try { foco.focus({ preventScroll: true }); } catch (e) {} }, RM ? 60 : 420);
    }
    document.addEventListener('keydown', tecla, true);
    $('.agc-jg-x').addEventListener('click', function () { cierra('x'); });
    $('.agc-jg-no').addEventListener('click', function () { cierra('ahora_no'); });
    $('.agc-jg-bg').addEventListener('click', function () { cierra('fondo'); });

    /* ---------- cambiar de pantalla ---------- */
    function paso(nombre) {
      var h0 = SHEET.offsetHeight;
      $$('.agc-jg-step').forEach(function (s) { var on = s.getAttribute('data-step') === nombre; s.hidden = !on; s.classList.toggle('is-on', on); s.classList.remove('is-in'); });
      fase = nombre;
      var h1 = SHEET.offsetHeight, nuevo = R.querySelector('[data-step="' + nombre + '"]');
      if (!RM && SHEET.animate && Math.abs(h1 - h0) > 2) SHEET.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 460, easing: 'cubic-bezier(.22,1,.36,1)' });
      requestAnimationFrame(function () { requestAnimationFrame(function () { nuevo.classList.add('is-in'); }); });
      SHEET.scrollTop = 0;
      return nuevo;
    }

    /* ---------- el juego ---------- */
    function cuenta() { var n = {}; caras.forEach(function (k) { if (k) n[k] = (n[k] || 0) + 1; }); return n; }
    function voltea(card, k, quieto) {
      var idx = cards.indexOf(card); caras[idx] = k;
      var t = cara(k, W); card.querySelector('.agc-jg-face b').textContent = t;
      card.classList.toggle('is-premio', k === W);
      card.setAttribute('aria-label', 'Carta ' + (idx + 1) + ': ' + t);
      card.classList.add('is-up'); if (quieto) card.classList.add('is-quieto');
      card.setAttribute('aria-disabled', 'true');
    }
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (bloqueo || fase !== 'juego' || card.classList.contains('is-up')) return;
        var k = plan[toques]; if (!k) return;
        toques++;
        if (toques === 1) { guarda({ jugo: new Date().toISOString() }); R.classList.add('is-jugando'); }
        medir('toque', { n: toques, cara: k }, toques);
        vibra(6);
        voltea(card, k);
        bloqueo = true;
        setTimeout(function () {
          bloqueo = false;
          var n = cuenta();
          if (n[W] >= 3) return gana();
          hint.textContent = n[W] === 2 ? '¡Te falta una!' : toques === 1 ? (TRES ? 'Destapa 2 más' : 'Encuentra 2 más iguales') : 'Sigue buscando';
          if (n[W] === 2) { cards.forEach(function (c, i) { c.classList.toggle('is-par', caras[i] === W); }); vibra([8, 40, 8]); }
        }, RM ? 80 : 470);
      });
    });

    if (vuelta) { $('[data-step="premio"] .agc-jg-won').textContent = 'Tu premio sigue aquí'; paso('premio'); }

    function gana() {
      bloqueo = true; fase = 'gana';
      var ms = Math.round(performance.now() - t0);
      guarda({ gano: new Date().toISOString(), acabado: W });
      medir('gana', { toques: toques, acabado: W, ms: ms });
      hint.textContent = '¡3 iguales!';
      R.classList.add('is-gano');
      cards.forEach(function (c, i) { if (caras[i] === W) c.classList.add('is-match'); });
      vibra([12, 60, 24]);
      /* el resto del tablero se destapa solo, tenue: el reparto se ve completo */
      var resto = mazo.slice(); caras.forEach(function (k) { if (k) resto.splice(resto.indexOf(k), 1); });
      resto.sort(function () { return Math.random() - 0.5; });
      var j = 0;
      cards.forEach(function (c, i) { if (!caras[i]) { var k = resto[j++]; setTimeout(function () { voltea(c, k, true); }, RM ? 0 : 240 + j * 60); } });
      setTimeout(function () {
        var prem = paso('premio');
        if (!MOVIL) setTimeout(function () { var b = prem.querySelector('.agc-jg-opt'); if (b) b.focus({ preventScroll: true }); }, 500);
      }, RM ? 400 : 1500);
    }

    /* ---------- pregunta → correo ---------- */
    $$('.agc-jg-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-v'); molestia = MOLESTIAS.filter(function (m) { return m.v === v; })[0];
        b.classList.add('is-sel');
        medir('molestia', { v: v });
        setTimeout(function () {
          $('.agc-jg-mmol').textContent = molestia.t;
          paso('correo');
          if (!MOVIL) setTimeout(function () { var i = $('input[name="email"], input[name="tel"]'); if (i) i.focus({ preventScroll: true }); }, 480);
        }, RM ? 0 : 220);
      });
    });

    /* ---------- reclamar: solo correo; Klaviyo y el premio en paralelo, el premio nunca espera a Klaviyo ---------- */
    var enviando = false;
    $('.agc-jg-form').addEventListener('submit', function (e) {
      e.preventDefault();
      if (enviando) return;
      var err = $('.agc-jg-err'), ie = $('input[name="email"], input[name="tel"]'), email = '', tel = '';
      ie.classList.remove('is-mal'); err.textContent = '';
      if (WA) {
        /* 10 dígitos de México; se aceptan con 52 / 521 / +52 al inicio y con espacios o guiones */
        tel = (ie.value || '').replace(/\D/g, '');
        if (tel.length === 13 && tel.indexOf('521') === 0) tel = tel.slice(3); else if (tel.length === 12 && tel.indexOf('52') === 0) tel = tel.slice(2);
        if (!/^[2-9]\d{9}$/.test(tel)) { ie.classList.add('is-mal'); err.textContent = 'Revisa tu número: son 10 dígitos.'; ie.focus(); return; }
      } else {
        email = (ie.value || '').trim().toLowerCase();
        if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) { ie.classList.add('is-mal'); err.textContent = 'Revisa tu correo.'; ie.focus(); return; }
      }
      enviando = true;
      var btn = $('.agc-jg-cta'), lbl = btn.querySelector('span'); btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); lbl.textContent = 'Aplicando tu ' + PREMIO + '…';
      var kl = (WA ? klaviyoWa(tel, molestia) : klaviyo(email, '', molestia)).then(function (k) { medir('klaviyo', k); return k.r; }, function () { medir('klaviyo', { r: 'error', sub: 'js', perfil: 'js' }); return 'error'; });
      var cod = aplica();
      medir('reclama', { wa: WA ? 1 : 0, molestia: molestia ? molestia.v : '' });
      cod.then(function (ok) {
        if (ok) guarda({ rec: new Date().toISOString() });
        medir('codigo', { ok: ok ? 1 : 0 });
        kl.then(null, function () {});
        listoPaso(ok);
      });
    });
    function listoPaso(ok) {
      var p = paso('listo');
      p.querySelector('.agc-jg-t2').textContent = ok ? 'Listo, ya está en tu pedido' : 'Tu ' + PREMIO + ' está listo';
      p.querySelector('.agc-jg-note').textContent = ok ? (PRECIOS ? 'Elige tu paquete y lo verás aplicado en tu total.' : 'Se aplica solo al pagar.') : 'Escribe el código al pagar y se aplica.';
      vibra([10, 50, 18]);
      if (!MOVIL) setTimeout(function () { var b = p.querySelector('[data-elige]'); if (b) b.focus({ preventScroll: true }); }, 450);
    }
    $('[data-elige]').addEventListener('click', function () {
      medir('elige', {});
      cierra('elige', function () {
        if (H.classList.contains('agc-uno-open')) return;   /* ya está en el configurador: se queda ahí con el premio aplicado */
        var b = document.getElementById('agcAddBtn');
        if (b) b.click(); else if (window.AGCUno && AGCUno.open) AGCUno.open();
      });
    });
  }

  /* ---------- Klaviyo (API pública de cliente, solo la llave pública): suscripción a la lista + perfil con la respuesta ---------- */
  function klaviyo(email, tel, molestia) {
    var props = { agua_molestia: molestia ? molestia.t : '', aguacero_source: 'popup_juego', juego_codigo: CODIGO, juego_premio: PREMIO };
    var e164 = tel ? '+52' + tel : '';
    if (e164) props.whatsapp = e164;   /* se conserva la propiedad de siempre */
    /* suscripción (Pedro 2026-10-15: «y sí, llena el teléfono»): phone_number en E.164 en el perfil, consentimiento SOLO de correo.
       Revisión 2024-10-15: con el objeto subscriptions «solo se suscriben los canales que van ahí» (docs de Klaviyo, Create Client
       Subscription): el teléfono queda como dato del perfil, sin SMS. */
    var sub = function (conTel) {
      var at = { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
      if (conTel && e164) at.phone_number = e164;
      /* revisión 2025-01-15: con 2024-10-15 Klaviyo rechaza `subscriptions` (400) y ningún correo entraba a la lista desde el 15-oct; verificado 2026-10-26 */
      return { path: 'subscriptions/', revision: '2025-01-15', body: { data: { type: 'subscription', attributes: { custom_source: PRECIOS ? 'Popup juego estilo Grüns' : 'Popup juego Encuentra tu Aguacero', profile: { data: { type: 'profile', attributes: at } } }, relationships: { list: { data: { type: 'list', id: KL.list } } } } } };
    };
    var perfil = { path: 'profiles/', revision: KL.revision, body: { data: { type: 'profile', attributes: { email: email, properties: props } } } };
    if (DRY) {
      var jobs = [sub(true), perfil];
      try { console.info('[agc-juego] modo dry: Klaviyo no se llama', JSON.stringify(jobs)); } catch (e) {}
      window.__agcJuegoDry = { jobs: jobs, reintento_sin_telefono: e164 ? sub(false) : null };
      return Promise.resolve({ r: 'dry', tel: e164 ? 'dry' : 'no' });
    }
    /* estado real de cada llamada: número HTTP, 'tiempo' (10 s sin respuesta) o 'red' (bloqueada o sin conexión) */
    var manda = function (j) {
      return conTiempo(fetch(KL.base + j.path + '?company_id=' + KL.company, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', 'revision': j.revision }, body: JSON.stringify(j.body) })
        .then(function (r) { return r.status; }, function () { return 'red'; }), 10000).then(null, function () { return 'tiempo'; });
    };
    var bien = function (st) { return typeof st === 'number' && st >= 200 && st < 300; };
    /* si Klaviyo rechaza el teléfono (ya es de otro perfil o no es válido), se guarda igual el correo: misma suscripción sin phone_number */
    var suscribe = manda(sub(true)).then(function (st) {
      if (!e164 || bien(st) || !(typeof st === 'number' && st >= 400 && st < 500)) return { st: st, tel: e164 ? (bien(st) ? 'ok' : 'error') : 'no' };
      return manda(sub(false)).then(function (st2) { return { st: st2, tel: 'rechazado:' + st }; });
    });
    return Promise.all([suscribe, manda(perfil)]).then(function (x) {
      var s1 = x[0].st, s2 = x[1];
      return { r: bien(s1) && bien(s2) ? 'ok' : 'error', sub: String(s1), perfil: String(s2), tel: x[0].tel };
    });
  }

  /* ---------- Klaviyo por WhatsApp (brazo «wa» del A/B del canal): perfil con phone_number y el opt-in de WhatsApp como propiedad. Sin lista y sin
     consentimiento de SMS: los números se sacan de Klaviyo (whatsapp_optin = true, aguacero_source = popup_juego_wa) para el flujo de Revie ---------- */
  function klaviyoWa(tel, molestia) {
    var e164 = '+52' + tel;
    var job = { path: 'profiles/', revision: '2025-01-15', body: { data: { type: 'profile', attributes: { phone_number: e164, properties: {
      whatsapp: e164, whatsapp_optin: true, whatsapp_optin_fecha: new Date().toISOString(), whatsapp_optin_texto: 'Al reclamarlo aceptas recibir mensajes de Aguacero por WhatsApp.',
      agua_molestia: molestia ? molestia.t : '', aguacero_source: 'popup_juego_wa', juego_codigo: CODIGO, juego_premio: PREMIO } } } } };
    if (DRY) {
      try { console.info('[agc-juego] modo dry: Klaviyo no se llama', JSON.stringify(job)); } catch (e) {}
      window.__agcJuegoDry = { jobs: [job] };
      return Promise.resolve({ r: 'dry', canal: 'wa' });
    }
    return conTiempo(fetch(KL.base + job.path + '?company_id=' + KL.company, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', 'revision': job.revision }, body: JSON.stringify(job.body) })
      .then(function (r) { return r.status; }, function () { return 'red'; }), 10000).then(null, function () { return 'tiempo'; })
      .then(function (st) { return { r: typeof st === 'number' && st >= 200 && st < 300 ? 'ok' : 'error', perfil: String(st), canal: 'wa' }; });
  }

  /* ---------- el código al carrito: se SUMA a los que ya hay (nunca los quita); un reintento; nunca deja a nadie atorado ---------- */
  function aplica() {
    /* precio por paquete: el código depende de cuántas duchas lleve (JUEGO35-{n}) y lo pone el configurador al pagar */
    if (PRECIOS) { guarda({ rec: lee().rec || new Date().toISOString() }); avisa(); return Promise.resolve(true); }
    var una = function () {
      return conTiempo(jget('/cart.js'), 6000).then(function (c) {
        var ya = codigos(c); if (ya.indexOf(CODIGO) === -1) ya.push(CODIGO);
        return conTiempo(jpost('/cart/update.js', { discount: ya.join(','), attributes: { _agc_juego: brazo() + '|' + canal() + (FORZADO ? '|forzado' : '') + '|gano|reclamo' } }), 6000);
      }).then(function (c) { return codigos(c).indexOf(CODIGO) !== -1; });
    };
    /* al quedar aplicado, el configurador repinta su total con el 10% (agc-encuesta.js escucha agc-juego) */
    return una().then(null, function () { return una(); }).then(null, function () { return false; })
      .then(function (ok) { if (ok) { guarda({ rec: lee().rec || new Date().toISOString() }); avisa(); } return ok; });
  }
  /* ---------- teaser del borde (Pedro 2026-10-28: «agrega un teaser estetico como ese del lado izq pero sin que estorbe, solo en caso de que
     lo cierren sin reclamar su descuento»): pestaña vertical «Tu regalo» pegada a la izquierda, bajo la barra del logo (abajo tapaba la tarjeta); al tocarla reabre el juego (si ya
     jugó, directo a «Tu premio sigue aquí»). Se esconde con el juego abierto (con el configurador sí se ve) y desaparece al reclamar. ---------- */
  var TZ = null;
  function teaserOk() { var s = lee(); return !!s.cerro && !s.rec && !NOPOP && !ofertaB() && !enDays(); }
  function quitaTeaser() { if (TZ) { TZ.remove(); TZ = null; } }
  function teaser() {
    if (TZ || !teaserOk()) return;
    precarga().then(function () {
      if (TZ || !teaserOk()) return;
      TZ = document.createElement('button'); TZ.type = 'button'; TZ.className = 'agc-jg-tz'; TZ.setAttribute('aria-label', 'Abrir tu regalo');
      TZ.innerHTML = '<span class="agc-jg-tz-i" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="8.5" width="17" height="4" rx="1"/><path d="M5 12.5V20h14v-7.5M12 8.5V20M12 8.5c-1.5-3.2-5.5-3.5-5.5-1.2 0 1.4 2.2 1.2 5.5 1.2zm0 0c1.5-3.2 5.5-3.5 5.5-1.2 0 1.4-2.2 1.2-5.5 1.2z"/></svg></span><span class="agc-jg-tz-t">Tu regalo</span>';
      TZ.addEventListener('click', function () { medir('teaser_abre', {}); TEASER = true; hecho = false; intenta('teaser'); });
      document.body.appendChild(TZ);
      requestAnimationFrame(function () { requestAnimationFrame(function () { if (TZ) TZ.classList.add('is-on'); }); });
      medir('teaser_ve', {});
    });
  }
  if (teaserOk()) setTimeout(teaser, 2500);
  function avisa() { try { document.dispatchEvent(new CustomEvent('agc-juego')); } catch (e) {} }
  /* el código también cuenta si ya está en el carrito (otra pestaña, el cajón del carrito): se revisa UNA vez al abrir el configurador */
  /* el configurador se pinta antes de que cargue este archivo: si ya reclamó, se le avisa al cargar y cada vez que se abre */
  var revisado = false, estabaAbierto = false;
  if (reclamado()) setTimeout(avisa, 0);
  if (window.MutationObserver) new MutationObserver(function () {
    var ab = H.classList.contains('agc-uno-open'), recien = ab && !estabaAbierto; estabaAbierto = ab;
    if (!recien) return;
    if (reclamado()) return avisa();
    if (!NOPOP && !hecho && !abierto) { noAntes = Date.now() + 650; intenta('config'); }   /* el carrito se revisa mientras el configurador se desliza (620 ms); el juego entra al terminar */
    if (revisado) return;
    revisado = true;
    if (OFF > 0) conTiempo(jget('/cart.js'), 5000).then(function (c) { if (codigos(c).indexOf(CODIGO) !== -1) { guarda({ rec: new Date().toISOString() }); avisa(); } }, function () {});
  }).observe(H, { attributes: true, attributeFilter: ['class'] });

  /* API para el pago de la PDP (agc-encuesta.js armaPedido): el código reclamado se suma al del paquete y el brazo viaja al pedido */
  window.AGCJuego = {
    brazo: brazo,
    canal: canal,
    attr: attr,
    codigo: function () { return reclamado() && !enDays() && !ofertaB() ? CODIGO : ''; },
    precios: PRECIOS,
    etiqueta: PREMIO,
    codigoPara: function (n) { return reclamado() && !enDays() && !ofertaB() ? (PRECIOS ? CODIGO + Math.max(1, Math.min(3, n || 1)) : CODIGO) : ''; },
    pct: OFF,   /* % del código del juego (ajuste juego_off): JUEGO-AGUA10 = 10 (13-oct), JUEGO-AGUA5 = 5 (Pedro 2026-10-18) */
    img: function () { return D.ducha || IMG[lee().acabado] || IMG.plata; },
    abre: function () { if (abierto) return; FORZADO = true; hecho = false; intenta('manual'); },
    _reparto: reparto
  };
})();
